import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_SETTINGS = {
  publicDocumentDispatchEnabled: true,
};

export const SiteSettingsProvider = ({ children }) => {
  const [siteSettings, setSiteSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const refreshSiteSettings = useCallback(async () => {
    try {
      const response = await axios.get(`${API_URL}/api/public/site-settings`, {
        withCredentials: true,
      });
      setSiteSettings({
        publicDocumentDispatchEnabled: response.data?.public_document_dispatch_enabled !== false,
      });
    } catch (error) {
      setSiteSettings(DEFAULT_SETTINGS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshSiteSettings();
  }, [refreshSiteSettings]);

  const value = useMemo(() => ({
    ...siteSettings,
    loading,
    refreshSiteSettings,
  }), [siteSettings, loading, refreshSiteSettings]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
};
